import {
  UserFactor,
  SmsUserFactorProfile,
  CallUserFactorProfile,
} from "@okta/okta-sdk-nodejs";

export type Factor = Omit<UserFactor, "factorType" | "provider" | "id"> & {
  // Overriding existing attributes to make them required instead of optional
  id: string;
  factorType: FactorTypeEnum;
  provider: Provider;

  profile?: SmsUserFactorProfile | CallUserFactorProfile;
  key: FactorKey;
  flags: {
    isActive: boolean;
    isPhoneFactor: boolean;
    isTotpFactor: boolean;
    isPasskeyFactor: boolean;
  };
};
export type Factors = Factor[];

export type FactorOrder = FactorKey[];
export type FactorMap = Record<FactorKey, Factor>;
export type FactorData = {
  factorMap: FactorMap;
  factorOrder: FactorKey[];
};

export enum FactorTypeEnum {
  Totp = "token:software:totp",
  Sms = "sms",
  Call = "call",
  WebAuthn = "webauthn",
}

export type PhoneFactor = FactorTypeEnum.Sms | FactorTypeEnum.Call;

export enum FactorKey {
  GoogleAuth = "googleAuthFactor",
  OktaVerify = "oktaVerifyFactor",
  Sms = "smsFactor",
  Call = "callFactor",
  WebAuthn = "webauthnFactor",
}

export enum Provider {
  Google = "GOOGLE",
  Okta = "OKTA",
  Fido = "FIDO",
}
